/**
* Bug #475
* @Author Anish Chandran
* @Date 5 July 2021
*/
import { Empty } from 'components';
import style from './style/noresultFound.module.scss'
import NoDataFound from '../client/assets/images/no-data-found.svg'

interface Props {
    message: string,
    className?: React.CSSProperties | String
}

const NoResultFound = (props: Props) => {
    return (
        /** Bug#494
         *  @Author: Linda Susan Raju 
         *  @Date: 16 Jul 2021
         */
        <Empty
            className={`${style.child} ${props.className}`}
            image={NoDataFound}
            description={<span>{props.message}</span>}
        >
        </Empty>
        /**End Bug#502 */
    );
};

export default NoResultFound;

/** End  **/
